import { FC } from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';

interface Props {
    isHidden?: boolean;
    currentStep: number;
    steps: number;
}

export const ProgressBar: FC<Props> = (props) => {
    const { isHidden, steps, currentStep } = props;

    return (
        <div className={styles['progress-bar']}>
            {(isHidden ? [] : [...Array(steps)]).map((_, i) => (
                <div
                    key={i}
                    className={cn(styles['progress-bar__item'], {
                        [styles['progress-bar__item_passed']]: currentStep >= i,
                    })}
                />
            ))}
        </div>
    );
};
